import React from 'react';
import { AuthProvider } from '@descope/react-sdk';
import { AlertProvider } from 'context/AlertContext';
import AlertNotifications from 'components/molecules/AlertNotifications';
import MixpanelIdentifier from 'components/analytics/MixpanelIdentifier';
import AppRoutes from 'routes';
import 'assets/styles/index.css';

const App: React.FC = () => {
  const projectId = process.env.REACT_APP_DESCOPE_PROJECT_ID;
  const baseUrl = process.env.REACT_APP_DESCOPE_BASE_URL;

  if (!projectId) {
    console.error('REACT_APP_DESCOPE_PROJECT_ID is not defined in environment variables');
    return (
      <div className="error-container">
        <h1>Configuration Error</h1>
        <p>Missing Descope Project ID. Please check your environment configuration.</p>
      </div>
    );
  }

  return (
    <AuthProvider projectId={projectId} baseUrl={baseUrl}>
      <MixpanelIdentifier />
      <AlertProvider>
        <div className="app">
          <AppRoutes />
          <AlertNotifications />
        </div>
      </AlertProvider>
    </AuthProvider>
  );
};

export default App;
